import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { concatLatestFrom } from '@ngrx/operators';
import { catchError, map, of, switchMap } from 'rxjs';

import { StockService } from '../../core/services/stock.service';
import { selectStoreId } from '../auth/auth.selectors';
import { StockActions } from './stock.actions';

export const loadStock$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store), stock = inject(StockService)) =>
    actions$.pipe(
      ofType(StockActions.loadStock),
      concatLatestFrom(() => store.select(selectStoreId)),
      switchMap(([, storeId]) => {
        if (!storeId) {
          return of(StockActions.loadStockFailure({ error: 'Missing store id' }));
        }
        return stock.getMyStock(storeId).pipe(
          map((items) => StockActions.loadStockSuccess({ items })),
          catchError((err) =>
            of(
              StockActions.loadStockFailure({
                error: err?.error?.message ?? err?.message ?? 'Stock load failed',
              }),
            ),
          ),
        );
      }),
    ),
  { functional: true },
);
